module.exports = __webpack_public_path__ + "static/fonts/Fact-Compressed.e6a2702.woff";